import { NavLink } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import AuthNav from "./auth-nav";
import { useAuth0 } from "@auth0/auth0-react";
import { jwtDecode } from 'jwt-decode';
import { hasRoles } from '../common/auth0Common';

const MainNav = () => {
  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const dropdownRef = useRef(null);
  const { getAccessTokenSilently, getIdTokenClaims, user, isAuthenticated } = useAuth0();

  useEffect(() => {

    async function checkUserDetails() {
      if (isAuthenticated) {
        //check if user is company through claims and roles
        //const idToken = await getIdTokenClaims();
        let token = await getAccessTokenSilently();
        const payload = JSON.parse(atob(token.split(".")[1]));

        const decoded = jwtDecode(token);

      }
    }

    const handleResize = () => {
      if (window.innerWidth >= 992) {
        if (dropdownRef.current && dropdownRef.current.classList.contains("show")) {
          dropdownRef.current.classList.remove("show");
        }
      }
    };

    checkUserDetails();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    // <nav style={{boxShadow:"none"}} className="navbar navbar-expand-lg navbar-light bg-light p-3 mb-4">
    //   <div className="container-fluid d-flex justify-content-between align-items-center">
    <div className="col-7">
      {/* Dropdown Menu for small screens */}
      <div className="d-flex justify-content-end">
        <button
          className="navbar-toggler border-0"
          type="button"
          id="dropdownMenuButton"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style={{ outline: "none" }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <ul
          ref={dropdownRef}
          // className="dropdown-menu dropdown-menu-end mt-2 p-2 rounded border-0"
          className="dropdown-menu dropdown-menu-end mt-2 p-2 rounded"
          aria-labelledby="dropdownMenuButton"
          style={{ border: "1px solid black" }}  // Correct inline style as a JS object
        >
          <li className="nav-item">
            <NavLink
              to="/"
              exact
              className="dropdown-item underline"
              activeClassName="active underline-active"
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/products"
              exact
              className="dropdown-item underline"
              activeClassName="active underline-active"
            >
              Produkte
            </NavLink>
          </li>
          {hasRoles(user, ["deserver"]) &&
            <li className="nav-item">
              <NavLink
                to="/deserves"
                exact
                className="dropdown-item underline"
                activeClassName="active underline-active"
              >
                deserves
              </NavLink>
            </li>}
          {hasRoles(user, ["company"]) &&
            <li className="nav-item">
              <NavLink
                to="/allMyProducts"
                exact
                className="nav-link underline"
                activeClassName="active underline-active"
              >
                Meine Produkte
              </NavLink>
            </li>}
          {hasRoles(user, ["admin"]) &&
            <li className="nav-item">
              <NavLink
                to="/admin"
                exact
                className="nav-link underline"
                activeClassName="active underline-active"
              >
                Admin
              </NavLink>
            </li>}
          <li className="nav-item">
            <NavLink
              to="/profile"
              exact
              className="dropdown-item underline"
              activeClassName="active underline-active"
            >
              Profil
            </NavLink>
          </li>
          <li className="nav-item">
            <AuthNav />
          </li>
        </ul>
      </div>

      {/* Horizontal Menu for Larger Screens */}
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav mx-auto">
          <li className="nav-item">
            <NavLink
              to="/"
              exact
              className="nav-link underline"
              activeClassName="active underline-active"
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/products"
              exact
              className="nav-link underline"
              activeClassName="active underline-active"
            >
              Produkte
            </NavLink>
          </li>
          {hasRoles(user, ["deserver"]) &&
            <li className="nav-item">
              <NavLink
                to="/deserves"
                exact
                className="nav-link underline"
                activeClassName="active underline-active"
              >
                deserves
              </NavLink>
            </li>}
          {
            hasRoles(user, ["company"]) && (
              <li className="nav-item">
                <NavLink
                  to="/allMyProducts"
                  exact
                  className="nav-link underline"
                  activeClassName="active underline-active"
                >
                  Meine Produkte
                </NavLink>
              </li>
            )
          }
          {hasRoles(user, ["admin"]) &&
            <li className="nav-item">
              <NavLink
                to="/admin"
                exact
                className="nav-link underline"
                activeClassName="active underline-active"
              >
                Admin
              </NavLink>
            </li>}
          <li className="nav-item">
            <NavLink
              to="/profile"
              exact
              className="nav-link underline"
              activeClassName="active underline-active"
            >
              Profil
            </NavLink>
          </li>
          <li className="nav-item">
            <AuthNav />
          </li>
        </ul>

      </div>
    </div>
    // </nav>
  );
};

export default MainNav;
